module.exports = __webpack_public_path__ + "assets/img/b62c-ae.svg";